export function padTo2Digits(num: number) {
  return String(num).padStart(2, "0");
}
